import { Chip, ChipOwnProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import PaymentStatusEnum from '../../enums/paymentStatusEnum';

interface PaymentStatusChipProps {
	status: PaymentStatusEnum; // A general status
}

const PaymentStatusChip = ({ status }: PaymentStatusChipProps) => {
	const { t } = useTranslation();

	const getStatusLabel = (): string => {
		if (status === PaymentStatusEnum.Canceled) {
			return t('ui.status.cancelled');
		}

		return t(`ui.status.${status}`);
	};

	const getStatusColor = (): ChipOwnProps['color'] => {
		let color: ChipOwnProps['color'];
		switch (status) {
			case PaymentStatusEnum.Open:
				color = 'info';
				break;
			case PaymentStatusEnum.Overdue:
				color = 'warning';
				break;
			case PaymentStatusEnum.Paid:
				color = 'success';
				break;
			default:
				// upcoming, open (aka active)
				color = 'error';
				break;
		}

		return color;
	};

	return <Chip size='small' label={getStatusLabel()} color={getStatusColor()} />;
};

export default PaymentStatusChip;
